/**
 * Vehicle Stop Measurement Formatter.
 * @param {*} value
 * @param {*} row
 * @returns {*}
 */
window.vehicleStopMeasurementFormatter = function(value, row) {
    let html = '';
    if (parseInt(row.can_stop, 10) === 1) {
        html += '<button class="button-vehicle-stop-measurement btn btn-sm btn-outline-danger" data-id="'+row.vehicle_id+'" data-name="'+row.name+'">';
        html += __('Stop measurement');
        html += '</button>';
    } else {
        html += '<button class="btn btn-sm btn-outline-secondary disabled">';
        html += __('Stop measurement');
        html += '</button>';
    }
    return html;
};
